// 会社案内ページ：Google Maps の初期化
// 地図が画面に入ってから Maps API を読み込む遅延読み込み（Map Load 課金の削減）
function mapInit(mapId, title, markerLatLng, centerLatLng, zoom) {
  const options = {
    zoom: zoom || 16,
    center: markerLatLng,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    type: false,
    zoomControl: true,
    scrollwheel: false,
  };
  const style = [
    { featureType: 'transit', stylers: [{ saturation: -100 }] },
    { featureType: 'administrative', stylers: [{ visibility: 'off' }] },
    { featureType: 'poi', stylers: [{ saturation: -100 }] },
    { featureType: 'water', elementType: 'labels', stylers: [{ visibility: 'off' }] },
    { featureType: 'water', stylers: [{ color: '#e9e9e9' }, { lightness: 100 }] },
    { featureType: 'road', elementType: 'labels', stylers: [{ visibility: 'off' }] },
    { featureType: 'road', stylers: [{ saturation: -100 }] },
    { featureType: 'landscape', stylers: [{ saturation: -100 }, { lightness: 10 }] },
  ];
  const map = new google.maps.Map(document.getElementById(mapId), options);
  new google.maps.Marker({ position: markerLatLng, map, title });
  map.mapTypes.set('noText', new google.maps.StyledMapType(style, options));
  map.setMapTypeId('noText');
  if (centerLatLng) map.setCenter(centerLatLng);
  return map;
}

// Maps API の読み込み完了後にコールバックとして呼ばれる（&callback=window.initMap）
// バンドル後もグローバルから参照できるよう window に明示代入する
window.initMap = function () {
  mapInit(
    'map',
    '坂本会計',
    new google.maps.LatLng(35.606967, 140.117206),
    new google.maps.LatLng(35.609, 140.117206),
    16
  );
};

let mapApiRequested = false;

// Maps API スクリプトを動的注入（1回だけ）。URL/キーは PHP 側で window.GMAP_API_SRC に出力済み
function loadMapApi() {
  if (mapApiRequested || !window.GMAP_API_SRC) return;
  mapApiRequested = true;
  const script = document.createElement('script');
  script.src = window.GMAP_API_SRC;
  script.async = true;
  document.head.appendChild(script);
}

document.addEventListener('DOMContentLoaded', () => {
  const target = document.getElementById('map');
  if (!target) return;
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          loadMapApi();
          observer.disconnect();
          break;
        }
      }
    },
    { rootMargin: '200px' } // 200px手前で先読みし表示の待ちを軽減
  );
  observer.observe(target);
});
